var token = document.head.querySelector('meta[name="csrf-token"]').getAttribute('content');

// load_data(id="", token);
function aspect_ratio(selector, x, y){
    var selector = $('.'+selector);
    var w = selector.width();
    var ratio = w*y/x;
    // var h = w.height();
    selector.height(parseInt(ratio));
}

function load_mas_posts(id, type, token) {
    $.ajax({
        url:"/load_recetas",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setRecetas').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts').hide();
            }
            $('#getRecetas').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
        }
    });
}

$(document).on('click', '#getRecetas', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');

    load_mas_posts(id, type, token);
});

function load_posts_top(id, type, token) {
    $.ajax({
        url:"/load_posts_top",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setPosts_t').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts').hide();
            }
            $('#getPosts_t').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
        }
    });
}

$(document).on('click', '#getPosts_t', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');
    load_posts_top(id, type, token);
});

function load_posts_bottom(id, type, token) {
    $.ajax({
        url:"/load_posts_bottom",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setPosts_b').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts_b').hide();
            }
            $('#getPosts_b').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
        }
    });
}

$(document).on('click', '#getPosts_b', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');
    load_posts_bottom(id, type, token);
});

function load_posts_calendario(id, type, token) {
    $.ajax({
        url:"/load_posts_calendario",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setPosts_cal').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts_cal').hide();
            }
            $('#getPosts_cal').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
            aspect_ratio('ratio_1a1', 1, 1);
        }
    });
}

$(document).on('click', '#getPosts_cal', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');
    load_posts_calendario(id, type, token);
});

function load_lugares_posts(id, type, token) {
    $.ajax({
        url:"/load_lugares_posts",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setLugares').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts_lugares').hide();
            }
            $('#getLugares').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
        }
    });
}

$(document).on('click', '#getLugares', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');
    load_lugares_posts(id, type, token);
});

function load_colaboradores(id, type, token) {
    $.ajax({
        url:"/load_colaboradores",
        method:"POST",
        data:{id:id, type:type, _token:token},
        success:function(data){
            $('#setColaboradores').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts_colaboradores').hide();
            }
            $('#getColaboradores').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
            aspect_ratio('img_colaboradores', 77, 100);
        }
    });
}

$(document).on('click', '#getColaboradores', function(){
    var id = $(this).attr('data-id');
    var type = $(this).attr('data-type');
    load_colaboradores(id, type, token);
});

function load_tag_category_posts(ruta, token) {
    $.ajax({
        url:ruta,
        method:"POST",
        data:{_token:token},
        success:function(data){
            $('#set_tag_category_posts').append(data);
            var last_id = $('#last_id').val();
            if (last_id == '-1') {
                $('#btn_load_posts').hide();
            }
            $('#get_tag_category_posts').attr('data-id', last_id);
            $('#last_id').remove();
            $('.lds-spinner').addClass('static');
            aspect_ratio('grilla_variada', 3, 4);
        }
    });
}

$(document).on('click', '#get_tag_category_posts', function(){
    var ruta = $(this).attr('data-id');
    load_tag_category_posts(ruta, token);
});


// envio de suscripciones
(function($){

    suscribiteme('emailSubscription', 'showMessage');
    suscribiteme('emailSubscription_top', 'showMessage_top');

    function suscribiteme(id, id_message){
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': token
            }
        });
        $('#'+id).submit(function(e) {
            // var email = $('#newsletter_email').val();
            var email = $('#'+ id +' input[type="email"]').val();
            $('#'+ id +' .loading_only').show();
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: '/suscripciones/sendmail',
                data: {newsletter_email:email},
                success: function(data){
                    if(data.status == 'success'){
                        $('#'+id+' .loading_only').hide();
                        $('#'+id_message).show();
                        $('#'+id_message).addClass('alert-success');
                        $('#'+id_message+' .pushMessage').text(data.message);
                        $('#'+ id +' input[type="email"]').val('');
                    }
                    if(data.status == 'error'){
                        $('#'+id+' .loading_only').hide();
                        $('#'+id_message).show();
                        $('#'+id_message).addClass('alert-danger');
                        $('#'+id_message+' .pushMessage').text(data.message);
                        $('#'+ id +' input[type="email"]').val('');
                    }
                }
            });
        });
    }
})(jQuery);
